import Vue from 'vue';
import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from '@/mixins/HttpMixin';
import {CampaignItem} from "@/components/communications/CommunicationInterfaces";
import {ViewStateType} from "@/enums/ViewStateType";
import { ContactType } from "@/components/communications/models/contactModel";
import {DateTime} from "luxon";
import debounce from "lodash.debounce";

export default Vue.component('message-inbox-card', {
  name: 'CampaignInboxCard',
  props: {
    contactType: { type: Object },
    providerId: { type: Number },
    facilityContactId: { type: Number },
  },
  data () {
    return {
      campaigns: [] as CampaignItem[],
      messageSearchText: '',
      currentDate: new Date(),
      intervalCurrentDate: null as any,
      searchInput: '',
      performSearchTimeout: null as any,
      loadingSearchResults: false,
      defaultLoggedInUser: {},
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner,
  },
  mixins: [ HttpMixin ],
  watch: {
  },
  async created () {
    this.searchInput = this.$store.state.viewState[ViewStateType.COMMUNICATION_SEARCH] ? this.$store.state.viewState[ViewStateType.COMMUNICATION_SEARCH] : '';
    this.intervalCurrentDate = setInterval( () => this.currentDate = new Date(), 1000 * 60);
    await this.debounceGetCampaigns();
  },
  beforeDestroy () {
    clearInterval(this.intervalCurrentDate);
  },
  computed : {
    debounceGetCampaigns(): () => void {
      return debounce(this.getCampaigns, 150, { maxWait: 1000 });
    }
  },
  methods: {
    // Don't call this directly! Call debounceGetCampaigns
    async getCampaigns () {
      let currentSearchInput = this.searchInput;
      await this.$store.dispatch('viewState/updateViewState', {
        name: ViewStateType.COMMUNICATION_SEARCH,
        value: currentSearchInput
      });
      const data = await (this as any).httpPost('/communications/campaigns/search', 'Failed to retrieve Campaigns.', {
        searchText: currentSearchInput,
        contactType: this.contactType.id,
        providerId: this.providerId,
        facilityContactId: this.facilityContactId,
      }) || [];
      this.campaigns = [] as CampaignItem[];
      const campaigns = {} as any;
      let cur = {} as any;
      for (let i = 0; i < data.length; i++) {
        cur = data[i]
        if (!(cur.campaignTitle in campaigns)) {
          campaigns[cur.campaignTitle] = {
            campaignId: cur.id,
            providerId: cur.providerId,
            facilityContactId: cur.facilityContactId,
            messageContent: cur.messageContent,
            subject: cur.subject,
            campaignTitle: cur.campaignTitle,
            teamMember: cur.teamMember,
            createdOn: DateTime.fromISO(cur.createdOn).toFormat('MM.dd.yyyy'),
            recipientIds: [],
          };
          this.campaigns.push(campaigns[cur.campaignTitle]);
        }
        if (this.contactType.id === ContactType.Provider) {
          campaigns[cur.campaignTitle].recipientIds.push(cur.providerId);
        } else if (this.contactType.id === ContactType.FacilityContact) {
          campaigns[cur.campaignTitle].recipientIds.push(cur.facilityContactId);
        }
      }
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/communications/cards/CampaignInboxCard.ts